import { render, staticRenderFns } from "./B2CAccesstrade.vue?vue&type=template&id=7e01fe16&"
import script from "./B2CAccesstrade.vue?vue&type=script&lang=js&"
export * from "./B2CAccesstrade.vue?vue&type=script&lang=js&"
import style0 from "./B2CAccesstrade.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports